import { render } from "./order_restore.vue?vue&type=template&id=36a8fd48"
import script from "./order_restore.vue?vue&type=script&lang=js"
export * from "./order_restore.vue?vue&type=script&lang=js"

import "./order_restore.vue?vue&type=style&index=0&id=36a8fd48&lang=css"

import exportComponent from "E:\\devops.aliyun\\liangting\\liangting_business_web\\seller.web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__